import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';

export const MobileActiveCallBarTrail = ({
  hasIncomingCalls,
  handleIcon,
  numOfIncomingCalls,
}: {
  hasIncomingCalls: boolean;
  handleIcon: (e: React.MouseEvent) => void;
  numOfIncomingCalls: number;
}) => {
  const { t } = useTranslation('softphone');

  return (
    <>
      <NakedButton
        onClick={handleIcon}
        css={css`
          border-radius: ${theme.borderRadius.small};
          display: flex;
          align-items: center;
          gap: ${theme.spacing(0.5)};
          ${hasIncomingCalls && `padding: ${theme.spacing(0.5, 1)};`}
          &:hover {
            background-color: ${hasIncomingCalls && theme.colors.success50};
            * {
              color: white;
            }
          }
        `}
      >
        {hasIncomingCalls && (
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -50, opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <Text
              size='medium'
              weight='bold'
              css={css`
                color: ${theme.colors.success30};
              `}
            >
              {t('+{{count}} New', { count: numOfIncomingCalls })}
            </Text>
          </motion.div>
        )}
        <Icon color='white' name='caret-right-small' />
      </NakedButton>
    </>
  );
};
